import { createFileRoute } from "@tanstack/react-router";

import { Ficha } from "./-ficha/-components/ficha";

export const Route = createFileRoute("/ficha")({
	component: Ficha,
});
